import { Link, NavLink, useLocation   } from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import {EventSourcePolyfill} from 'event-source-polyfill';
import { useEffect } from 'react';
import formatDateToCustomString from '../Component/ConverterDate'
import {addNotify} from '../Routes/index'
import  {Provider, useDispatch}  from 'react-redux';


export const Header = ({handleMenuClick,menuActive})=>{

  const utilisateurs = JSON.parse(sessionStorage.getItem("utilisateurs"))?.user

  console.log(utilisateurs)

  const handleRemove =() =>{
    sessionStorage.removeItem("utilisateurs")
    window.location.href = "/";
  }

  const navigate = useNavigate();
  
  const liens =(
    utilisateurs?(
    <>
              <li className="scroll-to-section"><a href="/#accueil">Accueil</a></li>
              <li className="scroll-to-section"><a href="/#about">A Propos</a></li>
              <li className="scroll-to-section"><a href="/#ministere"> Le ministère</a></li>
              <li className="scroll-to-section"><a href="/#dgid"> la dgid</a></li>
              <li>
              <NavLink to='/taxe' activeClassName='active'>
                  Taxe
            </NavLink>
              </li>
             
              <li>
                   
<NavLink to='/profil' activeClassName='active'>
    profil
</NavLink>
              </li> 
              
              <li className='monButton'>
                <Link onClick={handleRemove} className='monButton rosly'>
            Déconnection
            </Link>
            </li>

            <li className="scroll-to-section d-none">
                <div className="main-red-button"><Link to='/connection' className='active'>
            ospel
            </Link></div>
            </li>
    </>
   ):(
    <>
      <li className="scroll-to-section"><a href="#accueil" className="active">Accueil</a></li>
              <li className="scroll-to-section"><a href="#about">A Propos</a></li>
              <li className="scroll-to-section"><a href="#ministere"> Le ministère</a></li>
              <li className="scroll-to-section"><a href="#dgid"> la dgid</a></li>
              {/* <li className="scroll-to-section"><a href="#blog">Taxe</a></li>
              <li className="scroll-to-section"><a href="#contact">profil</a></li> */}
              <li className='monButton'>
                <Link to='/connection' className='monButton rosly'>
                connexion 
            </Link>
            </li>

            <li className="scroll-to-section d-none">
                <div className="main-red-button"><Link to='/connection' className='active'>
            ospel
            </Link></div>
            </li>
    </>
   )
  )


  const dispatch = useDispatch()
  useEffect(() => {
   initSSE();
  }, []);

  const initSSE = () => {
    let currentAgent = JSON.parse(sessionStorage.getItem("utilisateurs"));
    const ENDPOINT = "https://api-contribuable.onrender.com/notification-store/notification";
    
    const eventSource = new EventSourcePolyfill(ENDPOINT, {
      headers: {
        'Authorization': `Bearer ${currentAgent?.accessToken}`
      }
    });
    eventSource.addEventListener('message', (event) => {
      const eventData = JSON.parse(event.data);
      if (eventData.type === "facture") {
        const item = eventData.entity;
        const data = {
          key: eventData.entity.id,
          last_name: eventData.userAction.last_name,
          first_name: eventData.userAction.first_name,
          idFacture: eventData.entity.id,
          createdAt: eventData.entity.createdAt ,
          lastDelay: eventData.entity.lastDelay,
          civiliter: eventData.userAction.civiliter,
          payment: 0,
          title: eventData.entity?.tax?.title,
          penality: eventData.entity?.tax?.penality,
          rising: eventData.entity?.montant,
          isPayed: eventData.entity.isPayed
        };
        console.log("+++++++++",data)
        dispatch(addNotify(data))
          console.log('Ma notification : ', eventData)
      }
    })
    eventSource.onerror = (error) => {
      console.log("SSE connection error : ", error);
    };
  };
    
  
    return(
     
        <>
        
              <header style={{position: 'fixed'}} className="header-area header-sticky wow slideInDown" data-wow-duration="0.75s" data-wow-delay="0s">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <nav className="main-nav">
            <a href="index.html" className="logo">
              <h4>Taxe<span>Paye</span></h4>
            </a>

            

            <ul className="nav" style={{ display: menuActive ? 'block' : 'none' }}>
              
              {liens}
            </ul>
            <a className={`menu-trigger ${menuActive ? 'active' : ''}`} onClick={handleMenuClick}>
              <span>Menu</span>
            </a>
          </nav>
        </div>
      </div>
    </div>
  </header>
        </>
    )
}